import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { formatDate } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Alert, Button, Snackbar } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahHitunganSimulasi = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idHitunganSimulasi } = useParams();
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [no, setNo] = useState("");
  const [tglLelang, setTglLelang] = useState("");
  const [nominalLelang, setNominalLelang] = useState("");
  const [subsidi, setSubsidi] = useState("");
  const [angsuran, setAngsuran] = useState("");
  const [cadangan, setCadangan] = useState("");
  const [totalPenerimaanLelang, setTotalPenerimaanLelang] = useState("");
  const [lelangUndi, setLelangUndi] = useState("");
  const [sisaPeriode, setSisaPeriode] = useState("");
  const [hutang, setHutang] = useState("");
  const [yangSudahDisetor, setYangSudahDisetor] = useState("");
  const [totalSetor, setTotalSetor] = useState("");
  const [uangYangDiterima, setUangYangDiterima] = useState("");
  const [selisih, setSelisih] = useState("");
  const [bunga, setBunga] = useState("");
  const [telatBulan, setTelatBulan] = useState("");
  const [nominalTerlambat, setNominalTerlambat] = useState("");
  const [adm1, setAdm1] = useState("");
  const [adm2, setAdm2] = useState("");
  const [adm3, setAdm3] = useState("");
  const [patokanHarga, setPatokanHarga] = useState("");
  const [pendapatanAdm, setPendapatanAdm] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getHitunganSimulasiById();
  }, []);

  const getHitunganSimulasiById = async () => {
    setLoading(true);
    const pickedHitunganSimulasi = await postRequest(
      `/hitunganSimulasis/${idHitunganSimulasi}`,
      {},
      navigate,
      dispatch,
    );
    setNo(pickedHitunganSimulasi.data.no);
    setTglLelang(
      pickedHitunganSimulasi.data.tglLelang &&
        formatDate(pickedHitunganSimulasi.data.tglLelang),
    );
    setNominalLelang(pickedHitunganSimulasi.data.nominalLelang);
    setSubsidi(pickedHitunganSimulasi.data.subsidi);
    setAngsuran(pickedHitunganSimulasi.data.angsuran);
    setCadangan(pickedHitunganSimulasi.data.cadangan);
    setTotalPenerimaanLelang(pickedHitunganSimulasi.data.totalPenerimaanLelang);
    setLelangUndi(pickedHitunganSimulasi.data.lelangUndi);
    setSisaPeriode(pickedHitunganSimulasi.data.sisaPeriode);
    setHutang(pickedHitunganSimulasi.data.hutang);
    setYangSudahDisetor(pickedHitunganSimulasi.data.yangSudahDisetor);
    setTotalSetor(pickedHitunganSimulasi.data.totalSetor);
    setUangYangDiterima(pickedHitunganSimulasi.data.uangYangDiterima);
    setSelisih(pickedHitunganSimulasi.data.selisih);
    setBunga(pickedHitunganSimulasi.data.bunga);
    setTelatBulan(pickedHitunganSimulasi.data.telatBulan);
    setNominalTerlambat(pickedHitunganSimulasi.data.nominalTerlambat);
    setAdm1(pickedHitunganSimulasi.data.adm1);
    setAdm2(pickedHitunganSimulasi.data.adm2);
    setAdm3(pickedHitunganSimulasi.data.adm3);
    setPatokanHarga(pickedHitunganSimulasi.data.patokanHarga);
    setPendapatanAdm(pickedHitunganSimulasi.data.pendapatanAdm);
    setLoading(false);
  };

  const updateHitunganSimulasi = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() && no.length !== 0) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/updateHitunganSimulasi/${idHitunganSimulasi}`,
          {
            kelompokId: id,
            nominalLelang,
            subsidi,
            angsuran,
            cadangan,
            totalPenerimaanLelang,
            lelangUndi,
            sisaPeriode,
            hutang,
            yangSudahDisetor,
            totalSetor,
            uangYangDiterima,
            selisih,
            bunga,
            telatBulan,
            nominalTerlambat,
            adm1,
            adm2,
            adm3,
            patokanHarga,
            pendapatanAdm,
          },
          navigate,
          dispatch,
        );
        setLoading(false);
        navigate(`/daftarKelompok/kelompok/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Detail Hitungan Simulasi</h5>
      <hr />
      <Card>
        <Card.Header>Detail Hitungan Simulasi</Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={updateHitunganSimulasi}
          >
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control disabled value={no} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control disabled value={tglLelang} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nominal Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={nominalLelang}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setNominalLelang(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Subsidi :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={subsidi}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setSubsidi(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Angsuran :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={angsuran}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAngsuran(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Cadangan :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={cadangan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setCadangan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Total Penerimaan Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={totalPenerimaanLelang}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTotalPenerimaanLelang(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Lelang Undi :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={lelangUndi}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setLelangUndi(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Sisa Periode :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={sisaPeriode}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setSisaPeriode(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Hutang :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={hutang}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setHutang(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Yang Sudah Disetor :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={yangSudahDisetor}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setYangSudahDisetor(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Total Setor :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={totalSetor}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTotalSetor(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Uang Yang Diterima :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={uangYangDiterima}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setUangYangDiterima(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Selisih :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={selisih}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setSelisih(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Bunga :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={bunga}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setBunga(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Telat Bulan :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={telatBulan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTelatBulan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Nominal Terlambat :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={nominalTerlambat}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setNominalTerlambat(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 1 :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={adm1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAdm1(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 2 :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={adm2}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAdm2(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 3 :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={adm3}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAdm3(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Patokan Harga :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={patokanHarga}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPatokanHarga(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Pendapatan Adm :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={pendapatanAdm}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPendapatanAdm(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() =>
                  navigate(
                    `/daftarKelompok/kelompok/${id}/hitunganSimulasi/${idHitunganSimulasi}`,
                  )
                }
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahHitunganSimulasi;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
